module.exports = __webpack_public_path__ + "img/kf.94bf2f95.jpeg";